import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { Image } from "expo-image";
import { LinearGradient } from "expo-linear-gradient";

export type ProfileCardProps = {
  color1: string;
  color2: string;
  language: string;
  phrase: string;
  imageSrc: number;
};

const ProfileCard: React.FC<ProfileCardProps> = ({
  color1,
  color2,
  language,
  phrase,
  imageSrc,
}) => {
  const [showPhrase, setShowPhrase] = useState(false);

  useEffect(() => {
    const timer = setInterval(
      () => {
        setShowPhrase((prev) => !prev);
      },
      Math.random() * 3000 + 2000,
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <LinearGradient
      colors={[color1, color2]}
      style={styles.profileCard}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
    >
      <Image source={imageSrc} style={styles.profileImage} />

      <View />
      {showPhrase && (
        <View
          style={[
            styles.phraseContainer,
            language === "English" ? styles.phraseEnglish : styles.phraseOther,
          ]}
        >
          <Text style={styles.phraseText}>{phrase}</Text>
        </View>
      )}
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  profileCard: {
    width: "32%",
    height: 120,
    borderRadius: 16,
    marginBottom: 8,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  phraseContainer: {
    position: "absolute",
    maxWidth: "80%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    padding: 8,
    borderRadius: 12,
  },
  phraseEnglish: {
    bottom: 8,
    right: 8,
    transform: [{ rotate: "2deg" }],
  },
  phraseOther: {
    top: 8,
    left: 8,
    transform: [{ rotate: "-2deg" }],
  },
  phraseText: {
    fontSize: 12,
    color: "#1E40AF",
  },
  profileImage: {
    width: "32%",
    height: 120,
    borderRadius: 16,
    marginBottom: 8,
    aspectRatio: 1,
  },
});

export default ProfileCard;
